/**
 * Creator Access & Privacy Control Service
 * 
 * Manages privacy rules, visibility gates, and subscriber-only access
 * controls for creators across Stella web applications.
 */

// Canonical set of handles that are private / restricted to existing active subscribers only
export const PRIVATE_CREATOR_HANDLES = new Set([
  'imthejay',
  '01OctI1'
]);

/**
 * Checks if a given creator handle / urlPrefix is restricted to existing subscribers only.
 * Always performs case-insensitive matching regardless of casing in PRIVATE_CREATOR_HANDLES or input.
 * @param {string} urlPrefix - Creator handle or urlSuffix
 * @returns {boolean}
 */
export function isCreatorPrivate(urlPrefix) {
  if (!urlPrefix || typeof urlPrefix !== 'string') {
    return false;
  }
  const target = urlPrefix.trim().toLowerCase();
  for (const handle of PRIVATE_CREATOR_HANDLES) {
    if (typeof handle === 'string' && handle.trim().toLowerCase() === target) {
      return true;
    }
  }
  return false;
}

/**
 * Filter out private creators from public directory / explore listings.
 * @param {Array<Object>} creators - List of creator objects with urlSuffix or name
 * @returns {Array<Object>}
 */
export function filterPublicCreators(creators) {
  if (!Array.isArray(creators)) return [];
  return creators.filter(creator => {
    if (!creator) return true;
    if (creator.urlSuffix && isCreatorPrivate(creator.urlSuffix)) {
      return false;
    }
    if (creator.name && isCreatorPrivate(creator.name)) {
      return false;
    }
    return true;
  });
}
